import { Box, Button, Collapse, Grid, Typography } from "@mui/material"
import useAuth from "../../../../../../context/auth"
import { usePageTitle } from "../../../../../../hooks"
import {  BsWhatsapp } from "react-icons/bs"
import { useState } from "react"
import { Format } from "../../../../../../utils"

export const DefaultedContracts = () => {
    usePageTitle("Indique e ganhe - Contratos inadimplentes")
    const { user, handleBack } = useAuth()

    const [contracts, setContracts] = useState([
        {
            name: "NOME COMPLETO DO SÓCIO ADMINISTRADOR",
            phone: "00000000000"
        },
        {
            name: "NOME COMPLETO DO SÓCIO ADMINISTRADOR",
            phone: "00000000000"
        },
    ])

    const shareWhatsApp = (number: string) => {
        window.open(`https://wa.me/+55${number}`, '_blank')
    }

    return (
        <Grid
            display={"flex"}
            direction={"column"}
            gap={"2rem"}
            width={"100%"}
            height={"100%"}
        >
            <Typography fontWeight={600} fontSize={"2.4rem"} p={0} mb={"2rem"} mt={"1rem"}>Contratos inadimplentes</Typography>

            <Collapse in={contracts?.length > 0}>
                <Grid
                    display={"flex"}
                    direction={"column"}
                    gap={"1rem"}
                >
                    {contracts?.map((item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"1rem"}
                                padding={"2rem 1rem"}
                                boxSizing={"border-box"}
                                width={"100%"}
                                sx={{
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "10px"
                                }}
                            >
                                <Typography width={"100%"} textAlign={"left"} fontSize={"1.4rem"}>{item.name}</Typography>
                                <Grid
                                    display={"flex"}
                                    justifyContent={"flex-end"}
                                >
                                    <Button
                                        variant="outlined"
                                        startIcon={<BsWhatsapp size={18} color="rgba(28, 105, 0, 1)"/>}
                                        sx={{
                                            textDecoration: "underline",
                                            backgroundColor: "rgba(36, 135, 0, 0.07)",
                                            color: "rgba(28, 105, 0, 1)",
                                            width: "17.6rem",
                                            height: "3.1rem",
                                            borderColor: "rgba(36, 135, 0, 1)",
                                            fontSize: "1.2rem"
                                        }}
                                        onClick={() => shareWhatsApp(item.phone)}
                                    >{Format.whatsAppNumber(item.phone)}</Button>
                                </Grid>
                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>

            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem"
                    }}
                    variant="outlined"
                    onClick={handleBack}
                >Voltar</Button>
            </Grid>
        </Grid>
    )
}